<template>
  <div class="card bg-light">
    <div class="card-body">
      <strong>Terms &amp; Conditions</strong>
      <br /><br />
      <p>
        By using the website, these terms will automatically apply to you – you should make sure
        therefore that you read them carefully before using the website. You’re not allowed to copy,
        or modify our trademarks in any way. The website itself, and all the trade marks, copyright,
        database rights and other intellectual property rights related to it, still belong to Asobi.
      </p>
      <p>
        Asobi is committed to ensuring that the website is as useful and efficient as possible. For
        that reason, we reserve the right to make changes to the website or to charge for its
        services, at any time and for any reason. We will never charge you for the website or its
        services without making it very clear to you exactly what you’re paying for.
      </p>
      <p>
        The asobi website stores and processes personal data that you have provided to us, in order
        to provide my Service. It’s your responsibility to keep your phone and access to the website
        secure.
      </p>
      <div>
        <p>
          The website does use third party services that declare their own Terms and Conditions.
        </p>
        <p>
          Link to Terms and Conditions of third party service providers used by the website
        </p>
        <ul>
          <!----><!---->
          <li>
            <a
              href="https://firebase.google.com/terms/analytics"
              target="_blank"
              rel="noopener noreferrer"
              >Google Analytics for Firebase</a
            >
          </li>
          <!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!---->
        </ul>
      </div>
      <p>
        With respect to Asobi’s responsibility for your use of the website, when you’re using the
        website, it’s important to bear in mind that although we endeavour to ensure that it is
        updated and correct at all times, we do rely on third parties to provide information to us
        so that we can make it available to you. Asobi accepts no liability for any loss, direct or
        indirect, you experience as a result of relying wholly on this functionality of the website.
      </p>
      <p><strong>Changes to This Terms and Conditions</strong></p>
      <p>
        I may update our Terms and Conditions from time to time. Thus, you are advised to review
        this page periodically for any changes. I will notify you of any changes by posting the new
        Terms and Conditions on this page.
      </p>
      <p>
        These terms and conditions are effective as of 2020-06-15
      </p>
      <p><strong>Contact Us</strong></p>
      <p>
        If you have any questions or suggestions about my Terms and Conditions, do not hesitate to
        contact me at asobi.live@gmail.com.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>
